module.exports = __webpack_public_path__ + "img/sign.6014b7f3.svg";